import { useEffect, useState } from "react"
import { withRouter } from "react-router";
import { supabase } from "../../api";

import { STORAGE_URL } from "../../helpers/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft, faArrowCircleRight, faImage, faRepeat, faRotateLeft, faRotateRight, faUndo } from "@fortawesome/free-solid-svg-icons";



const PAGE_SIZE = 50

const BYTES_TOO_MANY = 1024*512


const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


const formatBytes = (b) => {
    if (b > 1024*1024) return `${Math.floor(b/(1024*1024))} Mb`
    return `${Math.floor(b/1024)} Kb`
}


const optimizeFile = async (bucket, path) => {

    const { data, error } = await supabase.functions.invoke("optimize-image", {
        body: {
            bucket,
            path,
        },
    });

    if (data) {
        console.log('done')
    }
    else {
        console.error(error)
    }
}


const FileLink = ({bucket, file, isSelected}) => {

    const [rnd, setRnd] = useState(Math.floor(Math.random()*9999999))

    const isTxt = file.name.includes('.csv') || file.name.includes('.json')


    if (!bucket || !file) return ''

    const rotateImage = async (bucket, path, angle) => {
        const { data, error } = await supabase.functions.invoke("rotate-image", {
            body: {
                bucket,
                path,
                angle
            },
        });
        
        if (data) {
            console.log('done')
        }
        else {
            console.error(error)
        }
        setRnd(Math.floor(Math.random()*9999999))
    }

    const fullPath = `${STORAGE_URL}/object/public/${bucket}/${file.name}?rnd=${rnd}`

    return (
        <div style={{display:'flex',flexDirection:'column',background:isSelected ? 'red' : 'white', margin:4, position:'relative', padding:3}}>
            
            {!isTxt && <img alt={file.name} style={{width:200}} className='photo' src={fullPath} />}
            {file.name} - {formatBytes(file.bytes)} 
            {!isTxt && <div style={{display:'flex', flexDirection:'row', justifyContent: 'center', alignItems: 'center', gap: 6}}>
            <FontAwesomeIcon icon={faRotateRight} />
            <button onClick={() => rotateImage(bucket, file.name, 90)}>90</button>
            <button onClick={() => rotateImage(bucket, file.name, 180)}>180</button>
            <button onClick={() => rotateImage(bucket, file.name, 270)}>270</button>
            </div>}
        </div>
    )
}



export const Storage = () => {

    const [loading, setLoading] = useState(false)

    const [mode, setMode] = useState('VIEW')
    const [page, setPage] = useState(-1)


    const [data, setData] = useState([])
    const [bucket, setBucket] = useState('')
    const [selected, setSelected] = useState(undefined)


    useEffect(() => {
        setPage(-1)

        if (bucket === 'imports-recipe') loadRecipeImportData('recipes')
        else if (bucket === 'imports-order') loadRecipeImportData('orders')
        else  loadImageData()
    }, [bucket, mode])


    const loadRecipeImportData = async (folder) => {

        const { data, error } = await supabase.rpc('list_storage_objects_with_bytes', {
    
            p_bucket: 'imports',
            p_prefix: folder,
            p_limit: 1000,
            p_offset: 0,
        });

        setData(data || [])

    }


    const loadImageData = async () => {

        const { data, error } = await supabase
            .rpc('list_storage_images', {
                bucketid: bucket,
                prefix: '',      // corresponds to the '' in your SQL
                limits: 3000,
                offsets: 0,       // corresponds to 0 in your SQL
            });


        let dataToProcess = data

        if (mode === 'CLEAN') {

            dataToProcess = dataToProcess.filter(d => d.bytes > BYTES_TOO_MANY)
        }

        setData(dataToProcess || [])

    }

    const showPage = (p) => {
        setPage(p)
    }

    const doProcess = async (images) => {

        if (!window.confirm('OPTIMIZE FUNCTION NEEDS CHANGING TO MATCH THE SUBSET')) return

        setLoading(true)
        for (let i =0; i< images.length; i++) {
            const img = images[i]

            setSelected(img)

            await optimizeFile(bucket, img.name)

            await sleep(1_500);

        }
        setSelected(undefined)
        setLoading(false)

    }

    const sortedFiles = data.sort((a,b) => a.name < b.name ? -1 : 1)

    const totalBytes = sortedFiles.reduce((sum, item) => sum + item.bytes, 0);

    const filesToShow = page !== -1 ? sortedFiles.slice(page*PAGE_SIZE,(page+1)*PAGE_SIZE) : []



    const sortedBySize = sortedFiles.sort((a,b) => a.bytes > b.bytes ? 1 : -1)

    return (

        <div className='outer center'>
        


        <h1>Storage</h1>


        <button className={mode === 'VIEW' ? 'inv' : ''} onClick={() => setMode('VIEW')}>View</button>
        <button className={mode === 'CLEAN' ? 'inv' : ''} onClick={() => setMode('CLEAN')}>Over {formatBytes(BYTES_TOO_MANY)}</button>

         &nbsp; &nbsp; &nbsp;

        <button className={bucket === 'imports-order' ? 'inv' : ''} onClick={() => setBucket('imports-order')}>Order Imports</button>
        <button className={bucket === 'imports-recipe' ? 'inv' : ''} onClick={() => setBucket('imports-recipe')}>Recipe Imports</button>
        <button className={bucket === 'recipes' ? 'inv' : ''} onClick={() => setBucket('recipes')}>Recipe <FontAwesomeIcon icon={faImage} /></button>
        <button className={bucket === 'customs' ? 'inv' : ''} onClick={() => setBucket('customs')}>Custom <FontAwesomeIcon icon={faImage} /></button>

        
        <hr/>
        {sortedFiles.length ? `Num files: ${sortedFiles.length}  Range: ${formatBytes(sortedBySize[0].bytes)} - ${formatBytes(sortedBySize[sortedBySize.length - 1].bytes)} Total: ${formatBytes(totalBytes)}` : ''}
        
        
        {mode === 'CLEAN' && page!==undefined && <button className='inv' disabled={loading} onClick={() => doProcess(filesToShow)}>{loading ? 'PROCESSING...' : 'START'}</button>}

        <hr/>

        {sortedFiles.length ? [...Array(Math.ceil(sortedFiles.length/PAGE_SIZE))].map((_,i) => <button className={page === i ? 'inv' : ''} onClick={() => showPage(i)}>{i+1}</button> ) : ''}


         <hr/>

        <div style={{display:'flex'}}>

             <div style={{display:'flex', flexDirection: 'row', width: '100%', flexWrap:'wrap'}}>
                {filesToShow.map(i => <FileLink bucket={bucket} isSelected={selected?.name === i?.name} file={i}/>)}
             </div>
             
             
        </div>
        
        </div>
    )

}

export default withRouter(Storage);